var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#EFB010",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2330 5109 c-259 -24 -511 -88 -763 -193 -327 -136 -665 -377 -902 -642 -384 -432 -602 -931 -655 -1499 -41 -446 55 -949 260 -1355 333 -659 950 -1158 1655 -1338 1094 -280 2232 187 2822 1157 260 427 390 922 369 1411 -36 876 -492 1646 -1245 2103 -456 277 -1014 406 -1541 356z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleIcon);
export default __webpack_public_path__ + "static/media/circle-icon.6504c17a1c31a4d717c9284dee94dd83.svg";
export { ForwardRef as ReactComponent };